import { graphql } from "react-relay";

export const UpdateCostReportingConfigMutation = graphql`
  mutation UpdateCostReportingConfigMutation(
    $input: UpdateCostReportingConfigInput!
  ) {
    updateCostReportingConfig(input: $input) {
      costReportingConfig {
        awsCostType
        azureCostType
        gcpCostType
        id
      }
    }
  }
`;
